import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isUndefined } from 'lodash';
import { CollapseBlock } from '../../../../common/index.jsx';
import { AttributePreview } from '../../../CMSPages/MeteoStation/components/AttributePreview.jsx';
import { AttributeIconRenderer } from '../../../CMSPages/MeteoStation/components/AttributeIconRenderer.jsx';
import { LastUpdatedAt } from './LastUpdatedAt.jsx';
import { getFirstCreatedAtFromSensorAttributes } from '../../../../../utils/helpers/CommonHelper.jsx';

export function CurrentSensorValues({ sensorsWithGraphableAttributes }) {
  const { t } = useTranslation();

  const lastUpdatedAtString = useMemo(() => {
    if (isUndefined(sensorsWithGraphableAttributes)) {
      return undefined;
    }

    for (const sensor of sensorsWithGraphableAttributes) {
      const firstCreatedAt = getFirstCreatedAtFromSensorAttributes(
        sensor?.sensor_attributes || [],
      );

      if (!isUndefined(firstCreatedAt)) {
        return firstCreatedAt;
      }
    }
  }, [sensorsWithGraphableAttributes]);

  return (
    <CollapseBlock collapsible title={t('Súčasné hodnoty')}>
      {sensorsWithGraphableAttributes.map((sensor) => (
        <article
          key={sensor.id}
          className="meteo-station-attribute-values-wrapper"
        >
          <h3>{sensor.name}</h3>
          <div className="meteo-sensor-detail-attribute-preview-wrapper">
            {sensor.sensor_attributes.map((attribute) => (
              <AttributePreview
                key={attribute.id}
                title={attribute.label}
                value={attribute.sensor_value?.value}
                unit={attribute.attribute_unit.unit}
                icon={<AttributeIconRenderer attribute={attribute} />}
              />
            ))}
          </div>
        </article>
      ))}

      <div className="meteo-station-page-last-updated-at-wrapper">
        <LastUpdatedAt lastUpdatedAtString={lastUpdatedAtString} />
      </div>
    </CollapseBlock>
  );
}
